import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { ImportGiftRowsService } from 'app/services/loyalty/import-gift-rows.service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-import-gift-rows-detail',
  templateUrl: './import-gift-rows-detail.component.html',
  styleUrls: ['./import-gift-rows-detail.component.css']
})
export class ImportGiftRowsDetailComponent implements OnInit {


  paginationType = KontableComponent.ServerPagination;
  customFilter = KontableComponent.CustomFilter;
  
  constructor(public importRowsService: ImportGiftRowsService, private translate: TranslateService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-import-gift/import-gift-rows-detail/import-gift-rows-detail.component.ts